import { bbox, circle } from '@turf/turf'
import { MERINIO_INITIAL_MAP_VIEW_SETTINGS, PADDING } from './constants'
import { Properties, Coordinates } from './types'

export const getInitialViewState = (features: GeoJSON.FeatureCollection<GeoJSON.Point, Properties> | undefined) => {
  if (!features) return MERINIO_INITIAL_MAP_VIEW_SETTINGS
  const [minLng, minLat, maxLng, maxLat] = bbox(features)
  const bounds = [
    [minLng, minLat],
    [maxLng, maxLat]
  ]
  return {
    bounds,
    fitBoundsOptions: {
      padding: {
        left: PADDING,
        top: PADDING,
        right: PADDING,
        bottom: PADDING
      }
    },
    longitude: 0,
    latitude: 0
  }
}

export const getCircleBounds = ({
  coordinates,
  radius
}: {
  coordinates?: Coordinates | null
  radius?: number | null
}): [[number, number], [number, number]] => {
  const { longitude, latitude } = coordinates || MERINIO_INITIAL_MAP_VIEW_SETTINGS
  const [minLng, minLat, maxLng, maxLat] = bbox(circle([longitude, latitude], radius || 100, { steps: 64, units: 'meters' }))
  return [
    [minLng, minLat],
    [maxLng, maxLat]
  ]
}

const CIRCLE_PADDING = 50

export const getCircleViewState = ({ coordinates, radius }: { coordinates?: Coordinates | null; radius?: number | null }) => {
  const bounds = getCircleBounds({ coordinates, radius })
  return {
    bounds,
    fitBoundsOptions: {
      padding: {
        left: CIRCLE_PADDING,
        top: CIRCLE_PADDING,
        right: CIRCLE_PADDING,
        bottom: CIRCLE_PADDING
      }
    },
    longitude: 0,
    latitude: 0
  }
}
